import { render, staticRenderFns } from "./PaymentMethod.vue?vue&type=template&id=093c1b47&"
import script from "./PaymentMethod.vue?vue&type=script&setup=true&lang=ts&"
export * from "./PaymentMethod.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./PaymentMethod.vue?vue&type=style&index=0&id=093c1b47&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports